<div class="placements-container">
	<div
		*ngFor="let placement of placements"
		class="placement-card-container"
		(click)="selectPlacement(placement)"
		[ngClass]="{ 'selected': placement.id == selectedPlacement?.id }"
		>
		<mat-card class="branding--select-placement-card branding--select-placement-card--{{placement.id}}">
			<mat-card-content>
				<div class="placement-card-content">
					<div class="branding--select-placement-card--image branding--select-placement-card--image--{{placement.id}}"></div>
					<div class="branding--select-placement-card--label branding--select-placement-card--label--{{placement.id}}">{{ placement.label }}</div>
				</div>
			</mat-card-content>
		</mat-card>
	</div>
</div>
